import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import moment from "moment";
import RingCountdown from "components/complex/countdown/RingCountdown";
import Workspace from "components/Workspace";
import DateFormats from "constants/DateFormats";
import GridBlock from "components/GridBlock";
import Typography from "components/BoldTypography";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import Tr from 'translations/Translations';

function ContractorClock(
    {
        endTimeCallback,
        dashboardSection
    }) {


    const [durations, setDurations] = useState([]);
    const [endTime, setEndTime] = useState(null);
    const [secondEndTime, setSecondEndTime] = useState(null);
    const [clockTitle, setClockTitle] = useState(null);
    const stageTr = useContext(OfferStageTranslationsContext);
    const noOfferStage = !!(dashboardSection?.noOfferStage);

    useEffect(() => {
        setDurations([])
        setEndTime(null)
        if (!dashboardSection) {
            return;
        }
        const end = moment(dashboardSection.offerEndDate);
        const nowTime = moment(dashboardSection.serverTime);
        const secondEnd = dashboardSection.offerSecondEndDate ? moment(dashboardSection.offerSecondEndDate) : null;

        if(dashboardSection.cancelled) {
            //nothing
        } else if (!dashboardSection.offerEndDate || nowTime.isSameOrAfter(end)) {
            setDurations([]);
            setEndTime(end.format(DateFormats.DATETIME_FORMAT));
            if (secondEnd) {
                if (nowTime.isSameOrAfter(secondEnd)) {
                    setSecondEndTime(secondEnd.format(DateFormats.DATETIME_FORMAT));
                } else {
                    setClockTitle(Tr("offer_second_end_date_left_time"));
                    setupDuration(secondEnd, dashboardSection.offerStartDate, nowTime);
                }
            }
        } else {
            setClockTitle(stageTr("left_to_offer_end_date"));
            setupDuration(end, dashboardSection.offerStartDate, nowTime);
        }
    }, [dashboardSection, stageTr]);

    const setupDuration = function(endTime, startDate, nowTime) {
        const duration2 = moment.duration(endTime.diff(nowTime));
        const number = duration2.asSeconds();

        const startTime = moment(startDate);
        const startDuration = moment.duration(endTime.diff(startTime));
        const startNumber = startDuration.asSeconds();

        setDurations([number, startNumber]);
    }

    return (
        <Workspace
            render={
                <>
                    {
                        !!endTime && <>
                            <GridBlock justify="center">
                                <Typography>{stageTr("offer_end_date_reached")}</Typography>
                            </GridBlock>
                            {!noOfferStage && <GridBlock justify="center">
                                <Typography>{endTime}</Typography>
                            </GridBlock>
                            }
                        </>
                    }

                    {
                        !!secondEndTime && <>
                            <GridBlock justify="center">
                                <Typography>{Tr("offer_second_end_date_reached")}</Typography>
                            </GridBlock>
                            <GridBlock justify="center">
                                <Typography>{secondEndTime}</Typography>
                            </GridBlock>
                        </>
                    }

                    {
                        !!dashboardSection.cancelled && <>
                            <GridBlock justify="center">
                                <Typography>{Tr("procedure_status_6")}</Typography>
                            </GridBlock>
                        </>
                    }
                    {!!durations.length && <RingCountdown duration={durations[0]} baseDuration={durations[1]} endTimeCallback={endTimeCallback} title={clockTitle}/>}
                </>}/>
    )

}

ContractorClock.propTypes = {
    dashboardSection: PropTypes.object,
    endTimeCallback: PropTypes.func.isRequired,
}

export default ContractorClock;